import {
  Button,
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  Drawer,
  Form,
  InputNumber,
  Row,
  Select,
  Space,
  Radio,
  Modal,
} from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import IntlMessage from '../../components/IntlMessage';
import dayjs from 'dayjs';
import moment from 'moment';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import { useIntl } from 'react-intl';
import RateForm from './RateForm';
import OptionsApi from '../../api/options';
import rateApi from '../../api/rates';
import useTime from '../../hooks/useTime';
import Currency from '../../components/Currency';
import History from './History';
import tourApi from '../../api/tour';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'moment-timezone';
import routesApi from '../../api/route';
import routeSegmentsApi from '../../api/route-segments';
import rateHistoriesApi from '../../api/rate-histories';
// moment.tz.setDefault('Asia/Bangkok');

const localizer = momentLocalizer(moment);

const { Option } = Select;

// const messages = {
//   agenda: 'Lịch',
//   allDay: 'Cả ngày',
//   month: 'Tháng',
//   day: 'Ngày',
//   today: 'Hôm nay',
//   previous: 'Trước',
//   next: 'Sau',
//   date: 'Ngày',
//   noEventsInRange: 'Không có lịch nào',
//   time: 'Giờ',
//   tomorrow: 'Ngày mai',
//   week: 'Tuần',
//   work_week: 'Tuần làm việc',
//   yesterday: 'Hôm qua',
// };

const Rates = () => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const isMount = useRef(false);
  const [items, setItems] = useState([]);
  // const [cGroupOptions, setCGroupOptions] = useState([]);
  const [reload, setReload] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [tours, setTours] = useState([]);
  const [options, setOptions] = useState([]);
  const [option, setOption] = useState(null);
  const [tour, setTour] = useState(null);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 100000,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
  });
  const [loading, setLoading] = useState(false);
  const { convertToAnyTimezone, formatAsISOString } = useTime();
  const [openHistoryModal, setOpenHistoryModal] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      if (filter.filter_name) {
        let result = await rateApi.getAll(filter);
        let events = result.data;
        events = events.map((item) => {
          // console.log(item.status);
          return {
            start: new Date(convertToAnyTimezone(item.date)),
            end: new Date(convertToAnyTimezone(item.date)),
            title: (
              <div
                style={{
                  padding: '0 5px',
                  backgroundColor: !item.status && '#999292ee',
                }}>
                <div>
                  <div>
                    Adult price:{' '}
                    {/* {cGroupSelected && cGroupSelected?.discount ? (
                        <Currency
                          style={{ color: '#fff' }}
                          value={
                            Number(item.price) -
                            (Number(cGroupSelected?.discount) *
                              Number(item.price)) /
                              100
                          }
                        />
                      ) : ( */}
                    <Currency
                      style={{ color: '#fff' }}
                      value={item.adult_price}
                    />
                    {/* )} */}
                  </div>
                  <div>
                    Child price:{' '}
                    <Currency
                      style={{ color: '#fff' }}
                      value={item.child_price}
                    />
                  </div>
                </div>
                <div>
                  <div>
                    Infant price:{' '}
                    <Currency
                      style={{ color: '#fff' }}
                      value={item.infant_price}
                    />
                  </div>
                  {/* <div>Seat: {item.seat.toLocaleString('vi-VN')}</div>
                  <div>
                    Booked:
                    {item.count_cabin ? item.count_cabin : 0}
                  </div> */}
                </div>
              </div>
            ),
            ...item,
          };
        });

        setItems(events);
      }
      setLoading(false);
    }
    fetchData();
  }, [filter, reload, option]);

  useEffect(() => {
    isMount.current = true;
    async function fetchData() {
      if (isMount) {
        var filter = {
          page: 1,
          limit: 1000,
          keyword: '',
          order_by: 'id',
          order_dir: 'DESC',
          filter_name: ['status'],
          filter_value: [1],
        };
        let tours = await routesApi.getAllAdmin(filter);
        var filter_option = {
          page: 1,
          limit: 1000,
          keyword: '',
          order_by: 'id',
          order_dir: 'DESC',
          filter_name: ['route_id', 'status'],
          filter_value: [tours?.data[0]?.id, 1],
        };
        let options = await routeSegmentsApi.getAll(filter_option);

        if (options.data.length > 0) {
          setOption(options.data[0]);
        }
        if (tours?.data?.length > 0) {
          setTour(tours.data[0]);
        }
        setTours(tours.data);

        setOptions(options.data);

        if (options.data.length > 0 && tours.data.length > 0) {
          setFilter((filter) => ({
            ...filter,
            route_id: tours?.data[0]?.id,
            filter_name: ['segment_id'],
            filter_value: [options.data[0].id],
          }));
        }
      }
    }
    fetchData();
    return () => {
      isMount.current = false;
    };
  }, []);

  const onReload = () => {
    setReload((reload) => !reload);
  };

  const onClose = () => {
    setOpen(false);
  };

  const showDrawer = () => {
    if (option) {
      setOpen(true);
    } else {
      Modal.warning({
        title: 'Please add segment before adding new rates',
        okText: intl.formatMessage({ id: 'global.close' }),
      });
    }
  };

  const handleChangeOption = async (e) => {
    const data = options.filter((item) => item.id === e);
    // var filterCabin = {
    //   page: 1,
    //   limit: 1000,
    //   keyword: '',
    //   order_by: 'id',
    //   order_dir: 'DESC',
    //   filter_name: ['route_id'],
    //   filter_value: [data[0].route.id],
    // };
    // let cabins = await cabinsApi.getAll(filterCabin);
    // if (cabins.data.length > 0) {
    //   setCabins(cabins.data);
    // }
    setOption(data[0]);
    // setCabin(cabins.data[0]);
    setFilter((filter) => ({
      ...filter,
      route_id: tour.id,
      filter_name: ['segment_id'],
      filter_value: [data[0].id],
    }));
  };

  const handleChangeTour = async (e) => {
    const data = tours.filter((item) => item.id === e);
    var filter_option = {
      page: 1,
      limit: 1000,
      keyword: '',
      order_by: 'id',
      order_dir: 'DESC',
      filter_name: ['route_id'],
      filter_value: [data[0].id],
    };
    let options = await routeSegmentsApi.getAll(filter_option);
    if (options.data.length > 0) {
      setOption(options?.data[0]);
    } else setOption(null);

    setTour(data[0]);
    setOptions(options.data);
    console.log(options.data);
    if (options.data.length > 0) {
      setFilter((filter) => ({
        ...filter,
        route_id: data[0]?.id,
        filter_name: ['segment_id'],
        filter_value: [options?.data[0].id],
      }));
    } else {
      setFilter((filter) => ({
        ...filter,
        route_id: data[0]?.id,
        filter_name: ['segment_id'],
        filter_value: [null],
      }));
    }
  };

  const handleEventClick = (event) => {
    // console.log(event);
    setSelectedEvent(event);
    setModalOpen(true);
  };

  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };

  const handleSubmit = () => {
    setLoading(true);

    form
      .validateFields()
      .then((values) => {
        let data = {
          ...values,
          segment_id: option.id,
        };
        data.from_date = formatAsISOString(data.from_date);
        data.to_date = formatAsISOString(data.to_date);
        let rateHistoryPayload = { ...data };
        rateHistoryPayload.price = data.adult_price;
        delete rateHistoryPayload?.year;
        rateHistoryPayload.week_days = rateHistoryPayload.weekdays
          .map((item) => {
            if (`${item}` === '1') return 'Monday';
            if (`${item}` === '2') return 'Tuesday';
            if (`${item}` === '3') return 'Wednesday';
            if (`${item}` === '4') return 'Thursday';
            if (`${item}` === '5') return 'Friday';
            if (`${item}` === '6') return 'Saturday';
            return 'Sunday';
          })
          .join(', ');
        delete rateHistoryPayload?.weekdays;
        Promise.all([
          rateApi.create(data),
          rateHistoriesApi.create(rateHistoryPayload),
        ])

          .then(() => {
            // console.log('aaa');
            setLoading(false);
            onClose();
            onReload();
            form.resetFields();
            // handleCancel();
            // props.onReload();
          })
          .catch((error) => {
            console.error(error);
            Modal.error({
              title: error.data.message,
              okText: intl.formatMessage({ id: 'global.close' }),
            });
            setLoading(false);
          });
      })
      .catch(() => setLoading(false));
  };

  const onOpenHistory = () => {
    setOpenHistoryModal(true);
  };

  const onCloseHistory = () => {
    setOpenHistoryModal(false);
  };

  const onClearRate = () => {
    Modal.confirm({
      title: intl.formatMessage({ id: 'global.clear_rate_confirm' }),
      okText: intl.formatMessage({ id: 'global.yes' }),
      onOk: async () => {
        await rateApi.clear({
          segment_id: option.id,
        });
        onReload();
      },
      onCancel() {},
    });
  };

  const handleChangeYear = (e) => {
    // console.log(e);
    if (e.includes('1')) {
      form.setFieldsValue({
        to_date: dayjs(form.getFieldValue('from_date')).add(365, 'day'),
      });
    } else {
      form.setFieldsValue({
        to_date: dayjs(form.getFieldValue('from_date')).add(1, 'month'),
      });
    }
  };

  const handleCreateStatus = () => {
    let data = {};
    const segmentIds = option.id;
    data.segment_id = segmentIds;
    data.weekdays = form.getFieldValue('weekdays');
    data.from_date = form.getFieldValue('from_date');
    data.to_date = form.getFieldValue('to_date');
    data.status = form.getFieldValue('status');
    // data.cabin_id = cabin.id;
    // console.log(data);
    routeSegmentsApi
      .updateStatusRates(data)
      .then(() => {
        setLoading(false);
        Modal.success({
          title: 'Success',
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        onReload();
        // handleCancel();
      })
      .catch((error) => {
        console.error(error);
        Modal.error({
          title: error.data.message,
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        setLoading(false);
      });
  };

  const itemsNest = [
    {
      key: '1',
      label: 'Status',
      children: (
        <>
          <Form.Item name="status">
            <Radio.Group>
              <Radio value={0}>
                <IntlMessage id="global.inactive" />
              </Radio>
              <Radio value={1}>
                <IntlMessage id="global.active" />
              </Radio>
            </Radio.Group>
          </Form.Item>
          <Button type="primary" size="small" onClick={handleCreateStatus}>
            Update
          </Button>
        </>
      ),
    },
  ];

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Row justify="space-between">
        <Col span={18}>
          <Space wrap={true}>
            <Select
              // mode={item.type}
              showSearch
              placeholder={'Select route'}
              onChange={handleChangeTour}
              style={{ minWidth: '200px' }}
              // allowClear={true}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              value={tour?.id}>
              {tours.length
                ? tours.map((tour, i) => {
                    return (
                      <Option key={i} value={tour.id}>
                        {tour?.start_location?.title} -{' '}
                        {tour?.end_location?.title}
                      </Option>
                    );
                  })
                : null}
            </Select>
            <Select
              // mode={item.type}
              showSearch
              placeholder={'Select segment'}
              onChange={handleChangeOption}
              style={{ minWidth: '200px' }}
              // allowClear={true}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              value={option?.id}>
              {options.length
                ? options.map((option, i) => {
                    return (
                      <Option key={i} value={option.id}>
                        {option?.start_stop?.title} - {option?.end_stop?.title}
                      </Option>
                    );
                  })
                : null}
            </Select>
          </Space>
        </Col>
        <Col>
          <Space>
            <Button type="primary" size="small" onClick={showDrawer}>
              <IntlMessage id="global.add_new" />
            </Button>
            <Button size="small" onClick={onOpenHistory} disabled={!option}>
              <IntlMessage id="global.history" />
            </Button>
            <Button
              size="small"
              danger
              onClick={onClearRate}
              disabled={!option}>
              <IntlMessage id="global.clear" />
            </Button>
          </Space>
        </Col>
      </Row>

      <Calendar
        localizer={localizer}
        events={items}
        defaultDate={new Date()}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 770, width: '100%' }}
        culture={'en'}
        timeslots={3}
        scrollToTime={new Date()}
        selectable={true}
        toolbar={true}
        // messages={messages}
        onSelectEvent={handleEventClick}
      />
      {modalOpen ? (
        <RateForm
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          currentData={selectedEvent}
          onReload={onReload}
        />
      ) : null}
      <Drawer
        title={`${option?.start_stop?.title} - ${option?.end_stop?.title}`}
        placement="right"
        onClose={onClose}
        open={open}
        footer={
          <Space>
            <Button
              key="submit"
              type="primary"
              htmlType="submit"
              loading={loading}
              onClick={handleSubmit}>
              {<IntlMessage id="global.save" />}
            </Button>
          </Space>
        }>
        <Form
          layout="vertical"
          form={form}
          initialValues={{
            weekdays: ['0', '1', '2', '3', '4', '5', '6'],
            status: 1,
            from_date: dayjs(),
            to_date: dayjs().add(30, 'day'),
            price: 1,
            seat: 1,
          }}
          labelAlign="left"
          onFinish={handleSubmit}
          onFinishFailed={onFinishFailed}>
          <Form.Item
            label={<IntlMessage id="global.from_date" />}
            name="from_date"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <DatePicker
              // showTime
              format={'DD/MM/YYYY'}
              style={{ width: '100%' }}
              // onChange={handleDate}
            />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.to_date" />}
            name="to_date"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <DatePicker
              // showTime
              format={'DD/MM/YYYY'}
              style={{ width: '100%' }}
              // onChange={handleDate}
            />
          </Form.Item>
          {/* <Form.Item
            label={<IntlMessage id="global.year" />}
            name="year"
            rules={[
              {
                required: false,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Checkbox.Group onChange={handleChangeYear}>
              <Checkbox value="1">Apply to 1 year</Checkbox>
            </Checkbox.Group>
          </Form.Item> */}
          <Form.Item
            label={<IntlMessage id="global.weekdays" />}
            name="weekdays"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Checkbox.Group
              style={{ width: '100%' }}
              //  onChange={onChange}
              value={['0', '1', '2', '3', '4', '5', '6']}>
              <Row>
                <Col span={6}>
                  <Checkbox value="1" checked>
                    Mon
                  </Checkbox>
                </Col>
                <Col span={6}>
                  <Checkbox value="2" defaultChecked>
                    Tue
                  </Checkbox>
                </Col>
                <Col span={6}>
                  <Checkbox value="3">Wed</Checkbox>
                </Col>
                <Col span={6}>
                  <Checkbox value="4">Thu</Checkbox>
                </Col>
                <Col span={6}>
                  <Checkbox value="5">Fri</Checkbox>
                </Col>
                <Col span={6}>
                  <Checkbox value="6">Sat</Checkbox>
                </Col>
                <Col span={6}>
                  <Checkbox value="0">Sun</Checkbox>
                </Col>
              </Row>
            </Checkbox.Group>
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.adult_price" />}
            name="adult_price"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <InputNumber
              min={1}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }
              style={{ width: '100%' }}
            />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.child_price" />}
            name="child_price"
            // rules={[
            //   {
            //     required: true,
            //     message: <IntlMessage id="global.requiredfield" />,
            //   },
            // ]}
          >
            <InputNumber
              min={1}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }
              style={{ width: '100%' }}
            />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.infant_price" />}
            name="infant_price"
            // rules={[
            //   {
            //     required: true,
            //     message: <IntlMessage id="global.requiredfield" />,
            //   },
            // ]}
          >
            <InputNumber
              min={1}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }
              style={{ width: '100%' }}
            />
          </Form.Item>
          {/* <Form.Item
            label={<IntlMessage id="global.seat" />}
            name="seat"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <InputNumber
              min={1}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }
              style={{ width: '100%' }}
            />
          </Form.Item> */}
          <Collapse items={itemsNest} />
        </Form>
      </Drawer>

      {openHistoryModal && (
        <History
          open={openHistoryModal}
          onClose={onCloseHistory}
          segment_id={option.id}
        />
      )}
    </Space>
  );
};

export default Rates;
